import React from 'react'
import cx from 'classnames'

import { AccordionContext } from './../../context'

import styles from './Panel.module.scss'

export const Panel = ({ children, className }) => {
  const { isOpen } = React.useContext(AccordionContext)

  return (
    <div
      className={cx(styles.panel, {
        [styles.opened]: isOpen,
        [className]: Boolean(className),
      })}
    >
      <div className={styles.content}>{children}</div>
    </div>
  )
}
